import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Car, MessageCircle } from "lucide-react";
import { api } from "../api/client";
import { useAuth } from "../context/AuthContext";
import { Avatar } from "../components/Avatar";
import { ru } from "../locales/ru";

export default function UserProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [profile, setProfile] = useState(undefined);

  useEffect(() => {
    api.get(`/users/${id}`).then(({ data }) => setProfile(data)).catch(() => setProfile(null));
  }, [id]);

  if (profile === undefined) return null;

  return (
    <div className="px-6 pt-8 pb-28" data-testid="user-profile-page">
      <button data-testid="back-button" onClick={() => navigate(-1)} className="p-2.5 rounded-full bg-gray-100 mb-6 active:scale-[0.95] transition-transform">
        <ArrowLeft size={20} />
      </button>
      {profile === null ? (
        <p className="text-gray-400" data-testid="user-not-found">{ru.profile.userNotFound}</p>
      ) : (
        <>
          <div className="flex flex-col items-start gap-4">
            <Avatar avatar={profile.avatar} name={profile.name} size={88} testId="public-avatar" />
            <div>
              <h1 className="text-3xl font-extrabold tracking-tight" data-testid="public-name">{profile.name}</h1>
              <div className="flex gap-1.5 mt-2 flex-wrap">
                {profile.roles.map((r) => (
                  <span key={r} className="text-[11px] font-semibold bg-gray-100 px-2 py-0.5 rounded-full">
                    {ru.roles[r] || r}
                  </span>
                ))}
              </div>
            </div>
          </div>
          {user?.id !== profile.id && (
            <button
              data-testid="write-message-button"
              onClick={() => navigate(`/chats/u/${profile.id}`)}
              className="mt-6 w-full h-12 bg-black text-white rounded-2xl font-medium flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
            >
              <MessageCircle size={18} /> {ru.chats.write}
            </button>
          )}
          {profile.roles.includes("driver") && profile.car && (
            <div className="mt-8 bg-gray-50 rounded-2xl p-5" data-testid="public-car-info">
              <div className="flex items-center gap-2 mb-3">
                <Car size={18} />
                <span className="font-bold">{ru.profile.driverSection}</span>
              </div>
              <p className="text-base font-semibold">{profile.car.model} {profile.car.color && `· ${profile.car.color}`}</p>
              {profile.car.plate && <p className="text-gray-500 font-mono mt-1">{profile.car.plate}</p>}
            </div>
          )}
        </>
      )}
    </div>
  );
}
